import { mapperModuleMedia } from '../../../core/data-layer/modules/mappers'
import type { MapperOptions, ModuleMedia } from '#layers/core/types'

export default (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }

  return {
    id: data.sys?.id || '',
    title: data.title || '',
    contentBlock1Media: mapperModuleMedia(data.contentBlock1Media, options.imageOptions),
    contentBlock2Media: mapperModuleMedia(data.contentBlock2Media, options.imageOptions),
    contentBlock1Text: data.contentBlock1Text || '',
    contentBlock2Text: data.contentBlock2Text || ''
  }
}
